// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sLNl","icon":"styles_icon__2o2vp"};